// @flow

import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import range from 'lodash/range'
import bindAll from 'lodash/bindAll'
import { Map } from 'immutable'

type Props = {
  fetchData: Function,
  addPageNumber: Function,
  addPerPageSize:Function,
  filterData: Map<string, any>,
  pagination: Map<string, any>,
  companyId: string
};


function logAndBindAll(context, methodNames) {
    methodNames.forEach((methodName) => {
        const originalMethod = context[methodName];
        context[methodName] = function(...args) {
			window.scrollTo(0, 0);
            return originalMethod.apply(context, args);
        }.bind(context);
    });
}

class Pagination extends React.Component<Props> {
	constructor(props) {
		super(props);

		const methodsToBind = [
            'handlePrevLinkClick',
            'handleNextLinkClick',
            'handleLinkClick',
            'handleLastClick',
            'handleFirstLinkClick'
        ];
		bindAll(this, [
			'pageRange'
			
		],methodsToBind)

		logAndBindAll(this, methodsToBind);

	}

	pageRange(): Array<number> {
		const { pagination } = this.props

		let startPage: number = 0
		let endPage: number = 0
		let pages: Array<number> = []

		const totalPages = Math.ceil(pagination.get('total') / pagination.get('per_page'))

	if (totalPages <= 3) {
      startPage = 1
      endPage = totalPages
    } else {

	if (pagination.get('current_page') == 1) {
        startPage = 1
        endPage = 3
      } else if (pagination.get('current_page') == pagination.get('last_page')) {
        startPage = pagination.get('last_page') - 2
        endPage = pagination.get('last_page')
      }else if(pagination.get('current_page') <= pagination.get('last_page') && pagination.get('current_page') >=  pagination.get('last_page')-2 ){
		startPage = pagination.get('last_page') - 3
        endPage = pagination.get('last_page')
	  } else if(pagination.get('current_page') >= 2 && pagination.get('current_page') <=3){
		startPage = 1
        endPage = 4
	  } else if(pagination.get('current_page') > pagination.get('last_page')){
			startPage = pagination.get('current_page') - 2
      endPage = pagination.get('current_page')
		}else {
        startPage = pagination.get('current_page') - 2
        endPage = pagination.get('current_page') + 2
      }




    }

		pages = range(startPage, endPage + 1)

		return pages
	}

	handlePrevLinkClick(): boolean | void {
		const {
			addPageNumber,
			fetchData,
			companyId,
			pagination,
			viewType,
			jobId,
			useCallback,
		} = this.props

		const pageNumber: number = pagination.get('current_page') - 1
		const totalPages: number = pagination.get('total') / pagination.get('per_page')

		if (pageNumber < 1 || pageNumber > totalPages){
			return false
		}

		addPageNumber(pageNumber).then(() => {
			if (viewType) {
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}else{
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}

		})
	}

	handleFirstLinkClick(e){

		const {
			addPageNumber,
			fetchData,
			companyId,
			pagination,
			viewType,
			jobId,
			useCallback,
		} = this.props

		const pageNumber: number = 1
		const totalPages: number = pagination.get('total') / pagination.get('per_page')

		if (pageNumber < 1 || pageNumber > totalPages){
			return false
		}

		addPageNumber(pageNumber).then(() => {
			if (viewType) {
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}else{
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}
		})

	}

	handleNextLinkClick(): boolean | void {
		const {
			addPageNumber,
			fetchData,
			companyId,
			pagination,
			viewType,
			jobId,
			useCallback,
		} = this.props

		const pageNumber: number = pagination.get('current_page') + 1
		const totalPages: number = pagination.get('total') / pagination.get('per_page')

		if (pageNumber < 1 || pagination.get('current_page') > totalPages) {
			return false
		}

		addPageNumber(pageNumber).then(() => {
			if (viewType) {
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}else{
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}
		})
	}

	handleLastClick(e){
		const {
			addPageNumber,
			fetchData,
			companyId,
			pagination,
			viewType,
			jobId,
			useCallback,
		} = this.props

		const pageNumber: number = pagination.get('last_page')


		if (pageNumber < 1 || pagination.get('current_page') > pagination.get('last_page')) {
			return false
		}

		addPageNumber(pageNumber).then(() => {
			if (viewType) {
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}else{
				if (useCallback) {
					return useCallback()
				}
				fetchData(this.props.filterData)
			}
		})
	}

	handleLinkClick(e) {
		const {
			addPageNumber,
			fetchData,
			companyId,
			addPerPageSize,
			perPageSize,
			viewType,
			jobId,
			useCallback,
		} = this.props

		const pageNumber: number = e.target.dataset.page

		addPageNumber(pageNumber).then(() => {
			if (perPageSize==0 || perPageSize==''|| perPageSize== undefined) {
				if (viewType) {
					if (useCallback) {
						return useCallback()
					}
					fetchData(this.props.filterData)
				}else{
					if (useCallback) {
						return useCallback()
					}
					fetchData(this.props.filterData)
				}
			}else{
				addPerPageSize(perPageSize).then(()=>{
						if (viewType) {
							if (useCallback) {
								return useCallback()
							}
							fetchData(this.props.filterData)
						}else{
							if (useCallback) {
								return useCallback()
							}
							fetchData(this.props.filterData)
						}
				})


			}


		})
	}

	render() {
		const { pagination } = this.props

		const pages: Array<Object> = []

		const totalPages = pagination.get('total') / pagination.get('per_page')

		if (pagination.get('flag') == 'template' || totalPages > 1) {
			if (pagination.get('current_page') == 1) {

				pages.push(
				<button
					type="button"
					key="page-first"
					className="btn btn-white btn-big disabled">
					<i className="fa fa-angle-double-left"></i> First
				</button>
			)
			pages.push(
				<button
					type="button"
					key="page-prev"
					className="btn btn-white btn-big disabled">
					<i className="fa fa-chevron-left"></i> Prev
				</button>
			)


			}else{

				pages.push(
				<button
					type="button"
					key="page-first"
					className="btn btn-white btn-big"
					onClick={this.handleFirstLinkClick}>
					<i className="fa fa-angle-double-left"></i> First
				</button>
			)
			pages.push(
				<button
					type="button"
					key="page-prev"
					className="btn btn-white btn-big"
					onClick={this.handlePrevLinkClick}>
					<i className="fa fa-chevron-left"></i> Prev
				</button>
			)


			}


			const pageRange: Array<number> = this.pageRange()

			if (pagination.get('current_page') >= 4) {

				pages.push(
				<button
					type="button"
					key="page-label"
					className="btn btn-white disabled">
					<i className="fa fa-ellipsis-h"></i>
				</button>
				)

			}

			for (var i = 0; i < pageRange.length; i++) {
				const pageNumber: number = pageRange[i]

				if (pageNumber === pagination.get('current_page')) {
					pages.push(
						<button type='button' className="btn btn-white btn-number active" key={'page-link-' + pageNumber}>{pageNumber}</button>
					)
				} else {
					pages.push(
						<button
							type='button'
							className="btn btn-white btn-number"
							data-page={pageNumber}
							key={"page-link-" + pageNumber}
							onClick={this.handleLinkClick}>
							{pageNumber}
						</button>
					)
				}
			}


			if (pagination.get('current_page') <= pagination.get('last_page')-3) {

					pages.push(
						<button
							type="button"
							key="page-label-last"
							className="btn btn-white disabled">
							<i className="fa fa-ellipsis-h"></i>
						</button>
					)

			}
				if (pagination.get('current_page')===pagination.get('last_page')) {

					pages.push(
						<button
							type="button"
							key="page-next"
							className="btn btn-white btn-big disabled">
							Next <i className="fa fa-chevron-right"></i>
						</button>
					)
					pages.push(
						<button
							type="button"
							key="page-last"
							className="btn btn-white btn-big disabled">
							Last <i className="fa fa-angle-double-right"></i>
						</button>
					)
				}else{

					pages.push(
						<button
							type="button"
							key="page-next"
							className="btn btn-white btn-big"
							onClick={this.handleNextLinkClick}>
							Next <i className="fa fa-chevron-right"></i>
						</button>
					)
					pages.push(
						<button
							type="button"
							key="page-last"
							className="btn btn-white btn-big"
							onClick={this.handleLastClick}>
							Last <i className="fa fa-angle-double-right"></i>
						</button>
					)

				}


		} else {
			pages.push(
				<button type='button' className="btn btn-white active" key='page-link-1'>1</button>
			)
		}

		const hidePageNumber = pagination.get('flag') == 'template' ? 'hide' : '';

		return(
			<div className="paginations-wrapper">
			  <div className={`progress-page ${hidePageNumber}`}>
			    <b>{pagination.get('from')} - {pagination.get('to')}</b> of {this.props.pagination.get('total')}
			  </div>
			  <div className="btn-group">
					{pages}
			  </div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		companyId: ownProps.match.params.companyId
	}
}

export default withRouter(connect(mapStateToProps, null)(Pagination))
